import React, { useState } from 'react'
import { Flex, Box } from 'rebass'

import { theme } from '../theme'
import { coreColors } from 'particles/colors'
import { spacing } from 'particles/styles'
import Text from 'particles/Text'

export interface Tab {
    id: string
    label?: string
    fontColor?: string
    render: any
}

interface TabSwitcherGrayProps {
    tabs: Tab[]
    selectedTab: string
    setTabEditorState: any
}

// TODO: Replace rebass component
const TabSwitcherGray: React.FC<TabSwitcherGrayProps> = ({ tabs, selectedTab, setTabEditorState }) => {
    const [selectedTabId, setSelectedTabId] = useState<string>(selectedTab)

    const handleSetTab = (tabId: string) => () => {
        setTabEditorState(tabId)
        setSelectedTabId(tabId)
    }

    return (
        <Flex
            flexDirection="column"
            bg={coreColors.white50}
            height="737px"
            overflow="hidden"
            sx={{ borderRadius: '8px' }}
        >
            <Flex justifyContent="center">
                {tabs.map(tab => {
                    const isSelected = tab.id === selectedTabId
                    return (
                        <Box
                            flex={1}
                            key={tab.id}
                            height="32px"
                            onClick={handleSetTab(tab.id)}
                            sx={{
                                boxShadow: isSelected
                                    ? `0 5px 0 ${theme.newColors.neutral100}, 0 0 5px rgba(0, 0, 0, 0.3)`
                                    : theme.newColors.neutral50,
                                cursor: 'pointer',
                                background: isSelected ? `${theme.newColors.neutral100}` : theme.newColors.neutral50,
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            <Text
                                scale={isSelected ? 'bodyM700' : 'bodyM400'}
                                color={isSelected ? 'action' : 'primary'}
                                style={{
                                    textAlign: 'center',
                                    width: '100%',
                                }}
                            >
                                {tab.label || tab.id}
                            </Text>
                        </Box>
                    )
                })}
            </Flex>
            <Box flex={1} px={spacing[300]} py={spacing[300]} bg={coreColors.grey100}>
                {selectedTabId &&
                    tabs.filter(tab => tab.id === selectedTabId)[0] &&
                    tabs.filter(tab => tab.id === selectedTabId)[0].render()}
            </Box>
        </Flex>
    )
}

export default TabSwitcherGray
